import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-412faf28"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "lottie-box-gift"
};
const _hoisted_2 = {
  class: "popup-prize-box"
};
const _hoisted_3 = {
  class: "cont"
};
const _hoisted_4 = {
  class: "canvas-box",
  ref: "canvasDom"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "quan-info"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "quan"
};
const _hoisted_10 = {
  class: "money"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "coin"
}, "￥", -1));
const _hoisted_12 = {
  class: "money"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tips"
}, "平台补贴红包", -1));
const _hoisted_14 = {
  class: "prize-info"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "info"
};
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = {
  class: "order"
};
const _hoisted_19 = {
  class: "lottie-box"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "btns"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompLottieAnimation = _resolveComponent("CompLottieAnimation");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createBlock(_component_van_overlay, {
    show: $options.show_pop,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => $options.show_pop = $event),
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [$data.showLottieAnimation ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CompLottieAnimation, {
      jsonUrl: "https://p6.moimg.net/mdwxapp/lottie_json/category_month_index_box.json",
      onOnAnimationComplete: $options.onAnimationComplete
    }, null, 8, ["onOnAnimationComplete"])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      class: "bg",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/md/icon/drawwinner_bg.png', 750)
    }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [$props.prizeInfo.is_free ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "bg",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month/category_month_index_prize_free.png', 750)
    }, null, 8, _hoisted_7)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("img", {
      class: "bg",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month/category_month_index_prize_quan.png', 750)
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("strong", _hoisted_12, _toDisplayString($props.prizeInfo.cashback_amount), 1)]), _hoisted_13])], 64))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
      class: "img",
      src: _ctx.$imgUrlFilter($props.prizeInfo.img, 478)
    }, null, 8, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString($props.prizeInfo.reward_title), 1), _createElementVNode("div", _hoisted_18, "订单号：" + _toDisplayString($props.prizeInfo.order_id), 1)])])], 512), _createElementVNode("div", _hoisted_19, [_createVNode(_component_CompLottieAnimation, {
      jsonUrl: "https://p6.moimg.net/mdwxapp/lottie_json/category_month_index_star.json",
      loop: true
    })]), _createElementVNode("img", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.closePopup && $options.closePopup(...args), ["stop"])),
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/md/icon/close.png', 48)
    }, null, 8, _hoisted_20)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
      class: "btn",
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.saveImage && $options.saveImage(...args), ["stop"])),
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/md/icon/saveimg.png', 260)
    }, null, 8, _hoisted_22), $props.prizeInfo.is_free ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("img", {
      class: "btn",
      onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.handleShareAction && $options.handleShareAction(...args), ["stop"])),
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month/category_month_index_prize_btn_showoff.png', 260)
    }, null, 8, _hoisted_23), _createElementVNode("img", {
      class: "btn-tips",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month/category_month_index_prize_tips.png', 136)
    }, null, 8, _hoisted_24)], 64)) : (_openBlock(), _createElementBlock("img", {
      key: 1,
      class: "btn",
      onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.handleShareAction && $options.handleShareAction(...args), ["stop"])),
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month/category_month_index_prize_btn_share.png', 260)
    }, null, 8, _hoisted_25))])], 512), [[_vShow, $data.showPrize]])]),
    _: 1
  }, 8, ["show"]);
}